<template>
    <div class="flex pb-4">
        <div class="flex flex-col">
            <div
                    @click="activate"
                    class="cursor-pointer relative rounded-full bg-grey-light flex items-center justify-center w-8 h-8 text-white"
                    v-bind:class="{'bg-blue-dark': active}"
            >
                {{ id }}
            </div>
            <div v-show="!last" class="mt-4 bg-grey-light w-px flex-1 mx-auto " style="min-height: 1vh;"></div>
        </div>
        <div class="pl-4 w-full">
            <div
                    class="cursor-pointer h-8 flex items-center mb-4"
                    @click="activate"
                    :class="{'text-grey': !active}"
            >
                <slot name="headline"></slot>
            </div>
            <slot name="default" v-if="active" :setStep="setStep"></slot>
            <a @click="activate">
                <slot class="cursor-pointer" v-if="!active" name="inactive"></slot>
            </a>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            'id': Number,
            'last': {
                type: Boolean,
                default: false,
            }
        },

        inject: ['stepperState'],

        computed: {
            active() {
                return this.stepperState.active === this.id;
            }
        },

        methods: {
            activate() {
                this.stepperState.active = this.id;
            },
            setStep: function (step) {
                this.stepperState.active = step;
            }
        },
    }

</script>
